import { lazyRouteComponent } from '@tanstack/react-router';
import { Contact, ShoppingBag } from 'lucide-react';
import type { WebModule } from '../web-module.ts';

/** Módulo Clientes nas telas (catálogo beadev-ai/catalogo). Os textos ficam em `customers.*`. */
export const webModule: WebModule = {
  id: 'customers',
  areas: [
    {
      id: 'sales',
      key: 'customers.area',
      icon: ShoppingBag,
      groups: [
        {
          key: null,
          items: [
            {
              to: '/customers',
              key: 'customers.nav.list',
              icon: Contact,
              permission: ['customers.customer.read', 'customers.customer.manage'],
            },
          ],
        },
      ],
    },
  ],
  routes: [
    {
      path: '/customers',
      component: lazyRouteComponent(() => import('./CustomersPage.tsx'), 'CustomersPage'),
    },
    {
      path: '/customers/$id',
      component: lazyRouteComponent(
        () => import('./CustomerDetailPage.tsx'),
        'CustomerDetailPage',
      ),
    },
  ],
  permissionAreas: [
    {
      id: 'customers',
      key: 'customers.area',
      processes: [
        {
          id: 'customers',
          key: 'customers.process',
          permissions: ['customers.customer.read', 'customers.customer.manage'],
        },
      ],
    },
  ],
};
